import Vue from "vue";
import Vuex from "vuex";
import App from "./Modules/App";
import LidarData from "./Modules/LidarData";
import MapData from "./Modules/MapData";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    App,
    MapData,
    LidarData,
  },
});
